import { render } from "./SelectItems.vue?vue&type=template&id=dc5554a6"
import script from "./SelectItems.vue?vue&type=script&lang=js"
export * from "./SelectItems.vue?vue&type=script&lang=js"
script.render = render

export default script